import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function Header({ onOpenDemoModal, onLogoClick }) {
  const [openDropdown, setOpenDropdown] = React.useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const closeAllDropdowns = () => {
    setOpenDropdown(null);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setOpenDropdown(null);
  };

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.nav-menu') && !e.target.closest('.hamburger-btn')) {
        closeAllDropdowns();
        setMobileMenuOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeAllDropdowns();
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  // Close mobile menu on route change
  React.useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  return (
    <header className="header" style={{ background: '#FFFFFF' }}>
      <div className="container header-container">
        <Link to="/" className="logo" onClick={onLogoClick}>
          <img src="/AstraVision_Logo.png" alt="Astravision Softech Private Limited" />
        </Link>

        {/* Hamburger Button - visible on mobile only */}
        <button
          className={`hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={(e) => { e.stopPropagation(); setMobileMenuOpen(!mobileMenuOpen); }}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`mobile-nav ${mobileMenuOpen ? 'mobile-nav-open' : ''}`} style={{ background: '#FFFFFF' }}>
          <ul className="nav-menu">
            <li><a href="#home" onClick={closeMobileMenu}>Home</a></li>
            
            <li className={`nav-item ${openDropdown === 'products' ? 'open' : ''}`}
                onClick={(e) => { e.stopPropagation(); }}>
              <a 
                className="nav-link" 
                href="#" 
                aria-haspopup="true" 
                aria-expanded={openDropdown === 'products' ? 'true' : 'false'}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown('products'); }}
              >
                Products
                <i className="fas fa-chevron-down" aria-hidden="true"></i>
              </a>
              <ul className="dropdown-menu" onClick={(e) => { e.stopPropagation(); }}>
                <li><a href="#" className={location.pathname === '/school-management/overview' ? 'active' : ''} onClick={(e) => { e.preventDefault(); navigate('/school-management/overview'); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img src="/absloute-logo.jpeg" alt="AbsoluteVision Logo" style={{ width: '24px', height: '24px', objectFit: 'contain', borderRadius: '4px' }} />School Management</a></li>
                <li><a href="#nabl-accreditation" onClick={closeMobileMenu}>NABL Accreditation</a></li>
                <li><a href="#herbalife" onClick={closeMobileMenu}>Herbalife</a></li>
              </ul>
            </li>
            
            <li><a href="#solutions" onClick={closeMobileMenu}>Solutions</a></li>
            
            <li className={`nav-item ${openDropdown === 'resources' ? 'open' : ''}`}
                onClick={(e) => { e.stopPropagation(); }}>
              <a 
                className="nav-link" 
                href="#" 
                aria-haspopup="true" 
                aria-expanded={openDropdown === 'resources' ? 'true' : 'false'}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown('resources'); }}
              >
                Resources
                <i className="fas fa-chevron-down" aria-hidden="true"></i>
              </a>
              <ul className="dropdown-menu" onClick={(e) => { e.stopPropagation(); }}>
                <li><a href="#blog" onClick={closeMobileMenu}>Blog</a></li>
                <li><a href="#documentation" onClick={closeMobileMenu}>Documentation</a></li>
                <li><a href="#case-studies" onClick={closeMobileMenu}>Case Studies</a></li>
              </ul>
            </li>
            
            <li className={`nav-item ${openDropdown === 'company' ? 'open' : ''}`}
                onClick={(e) => { e.stopPropagation(); }}>
              <a 
                className="nav-link" 
                href="#" 
                aria-haspopup="true" 
                aria-expanded={openDropdown === 'company' ? 'true' : 'false'}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown('company'); }}
              >
                Company
                <i className="fas fa-chevron-down" aria-hidden="true"></i>
              </a>
              <ul className="dropdown-menu" onClick={(e) => { e.stopPropagation(); }}>
                <li><a href="#about" onClick={closeMobileMenu}>About Us</a></li>
                <li><a href="#careers" onClick={closeMobileMenu}>Careers</a></li>
                <li><a href="#contact" onClick={closeMobileMenu}>Contact</a></li>
              </ul>
            </li>

            {/* Mobile-only Book a Demo button inside nav */}
            <li className="mobile-cta-item">
              <button 
                className="btn-primary" 
                onClick={() => { navigate('/demo-form'); closeMobileMenu(); }}
              >
                Book a Demo
              </button>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <button 
            className="btn-primary" 
            onClick={() => navigate('/demo-form')}
          >
            Book a Demo
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
 
 
